import {
    getLocalStorageJson,
    setLocalStorageJson,
} from '@common/utils/storage';

export type StoredOutcomeSummarySettings = {
    enabled: boolean;
    refreshHourLocal?: number | null;
    refreshMinuteLocal?: number | null;
    refreshLocalTime?: string | null;
    timezone?: string | null;
    lastGeneratedAt?: string | null;
    privacyAcceptedAt?: string | null;
    privacyNoticeVersion?: string | null;
    updatedAt?: string;
};

const OUTCOME_SUMMARY_SETTINGS_STORAGE_PREFIX = 'bustly:outcome-summary-settings:v1';

export const buildOutcomeSummarySettingsStorageKey = (workspaceId: string): string => (
    `${OUTCOME_SUMMARY_SETTINGS_STORAGE_PREFIX}:${workspaceId}`
);

export const readStoredOutcomeSummarySettings = (
    workspaceId: string,
): StoredOutcomeSummarySettings | null => {
    const stored = getLocalStorageJson<StoredOutcomeSummarySettings>(
        buildOutcomeSummarySettingsStorageKey(workspaceId),
    );

    return typeof stored?.enabled === 'boolean' ? stored : null;
};

export const writeStoredOutcomeSummarySettings = (
    workspaceId: string,
    settings: Omit<StoredOutcomeSummarySettings, 'updatedAt'>,
): StoredOutcomeSummarySettings => {
    const stored = {
        ...settings,
        updatedAt: new Date().toISOString(),
    };

    setLocalStorageJson(buildOutcomeSummarySettingsStorageKey(workspaceId), stored);
    return stored;
};
